import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiCommentDateTimeFormatOptions } from '@fi-shared/utils/format-date';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { ITextEditorLinkAttachment } from '@fi-shared/fi-text-editor/fi-text-editor';
import { ICommentModel } from '@fi-shared/fi-comments/fi-comments';
import { IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { ILightWeightUser } from '@fi-shared/models/access-right-filter-collection.model';

export class CommentModel implements ICommentModel {
    Id = 0;
    Content = '';
    CreatedOn = new Date().toISOString();
    ChangedOn = new Date().toISOString();
    ChangedOnDateTime = '';
    CreatedByUserId = 0;
    CreatedByUserName = '';
    ObjectId = 0;
    ObjectType = ObjectTypes.Post;
    Attachments = [];
    ContentLanguageId;
    UserProfile: IUserProfile;
    MediaBankFileReferences: IMediaBankFileReference[] = [];
    Links: ITextEditorLinkAttachment[] = [];
    ChildItems: CommentModel[] = [];
    TaggedUsers: ILightWeightUser[] = [];
    Reactions = [];
    ChangedByUserName: string;
    ChangedByUserId: boolean;

    // parent comment's Id
    ParentId = null;
    ForumId: number;

    constructor(fiFormatDateService: FiFormatDateService, comment?: CommentModel) {
        this.ChangedOnDateTime = fiFormatDateService.formatDate(this.ChangedOn, FiCommentDateTimeFormatOptions);

        if (comment) {
            this.Initialize(comment, fiFormatDateService);
        }
    }

    private Initialize(comment, fiFormatDateService: FiFormatDateService) {
        var self = this;
        this.Id = comment.Id;
        this.Content = comment.Content;
        this.CreatedByUserId = comment.CreatedByUserId;
        this.CreatedByUserName = comment.CreatedByUserName;
        this.CreatedOn = comment.CreatedOn;
        this.ChangedByUserId = comment.ChangedByUserId;
        this.ChangedByUserName = comment.ChangedByUserName;
        this.ChangedOn = comment.ChangedOn;
        this.ChangedOnDateTime = fiFormatDateService.formatDate(this.ChangedOn, FiCommentDateTimeFormatOptions);
        this.ObjectId = comment.ObjectId;
        this.ObjectType = comment.ObjectType;
        this.Attachments = comment.Attachments;
        this.ContentLanguageId = comment.ContentLanguageId;
        this.UserProfile = comment.UserProfile;
        this.MediaBankFileReferences = comment.MediaBankFileReferences;
        this.Links = comment.Links;
        this.ParentId = comment.ParentId;
        this.Reactions = comment.Reactions;
        this.TaggedUsers = comment.TaggedUsers;
        if (comment.ChildItems) {
            comment.ChildItems.forEach(function (childItem) {
                self.ChildItems.push(new CommentModel(fiFormatDateService, childItem));
            });
        }
    }
}
